import React from "react"
import PropTypes from "prop-types"

import styles from "./Cells.module.css"

const Cells = props => {
  const Items = props.items.map((item, index) => {
    return (
      <div className={styles.item} key={`cells${index}`}>
        {item}
      </div>
    )
  })

  return <div className={styles.container}>{Items}</div>
}

Cells.propTypes = {
  items: PropTypes.arrayOf(PropTypes.element),
}

export default Cells
